"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isDisabledDataHookInput = isDisabledDataHookInput;

/* eslint-disable @typescript-eslint/no-explicit-any */
// Data hooks can be called multiple ways and this type allows for the
// appropriate ones while enforcing types on combinations of input values.
// This type is a "helper type" in that it takes more basic types like
// variables, response, etc, and produces a complete type used to author
// a data hook.
// Here are the possible singatures you might see with a data hook:
// a) Normal call: useMyThing({ variables: { ... } })
// b) Conditional call: useMyThing({ variables: { ... }, config: { enabled: condition }})
// c) Without variables if not required: useMyThing({ config: { ... } })
// d) Off: useMyThing({ config: { enabled: false } })
function isDisabledDataHookInput(input) {
  var _input$config;

  if ((input === null || input === void 0 ? void 0 : (_input$config = input.config) === null || _input$config === void 0 ? void 0 : _input$config.enabled) === false) return true;
  return false;
}